"use client"

import ButtonWithArrow from "@/ui/common/bit/ButtonWithArrow"
import CommonTitle from "@/ui/common/bit/CommonTitle"
import FiltersWrapper from "@/ui/FiltersWrapper/FiltersWrapper"
import { mediaQueries, sizes } from "@/ui/theme/theme"
import { styled } from "@mui/material"
import BlockWrapper from "../../common/BlockWrapper"

export const StyledBlockWrapper = styled(BlockWrapper)`
  align-items: center;
  max-width: unset;
  padding: 0;
  width: 100%;
  ${mediaQueries.mobile} {
    padding: 56px 0 56px;
  }
`
export const StyledCommonTitle = styled(CommonTitle)`
  ${mediaQueries.mobile} {
    padding: 0 ${sizes.baseTriple};
  }
`
export const StyledFiltersWrapper = styled(FiltersWrapper)`
  width: 100%;
  margin-bottom: ${sizes.baseTriple};
  align-content: center;
`
export const StyledButtonWithArrow = styled(ButtonWithArrow)`
  margin-bottom: ${sizes.baseTriple};
`
